import { Alert, Button, Flex, Heading, Input, Stack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { LoadingOverlay } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { type FunctionComponent, useEffect } from "react";
import { Field } from "./field";
import { AuthLayout } from "./layout";

export const ForgottenPassword: FunctionComponent = observer(
  function ForgottenPassword() {
    const router = useRouter();
    const { authStore } = useStore();

    useEffect(() => {
      authStore.initForgottenPassword();
    }, []);

    return (
      <AuthLayout>
        <LoadingOverlay
          isLoading={authStore.forgottenPasswordForm.state === "loading"}
          position="absolute"
        >
          <Flex direction="column" gap="4">
            {authStore.forgottenPasswordForm.state === "success" && (
              <Alert status="success">
                <Trans>We have e-mailed your password reset link!</Trans>
              </Alert>
            )}
            <Stack
              as="form"
              onSubmit={(event) => {
                event.preventDefault();
                authStore.sendPasswordResetLink();
              }}
              spacing="6"
            >
              <Heading textAlign="center" size="lg">
                <Trans>Forgot password?</Trans>
              </Heading>
              <Field
                isInvalid={authStore.forgottenPasswordForm.email.hasError}
                label={t`E-Mail Address`}
                input={
                  <Input
                    autoComplete="email"
                    autoFocus
                    inputMode="email"
                    onChange={(event) =>
                      authStore.forgottenPasswordForm.email.onChange(
                        event.target.value,
                      )
                    }
                    required
                    type="email"
                    value={authStore.forgottenPasswordForm.email.value}
                  />
                }
                errorMessage={authStore.forgottenPasswordForm.email.error}
              />

              <Button
                colorScheme="violet"
                isLoading={
                  authStore.forgottenPasswordForm.state === "submitting"
                }
                type="submit"
              >
                <Trans>Send Password Reset Link</Trans>
              </Button>
              <Button
                onClick={() => {
                  router.push("/login");
                }}
                variant="link"
              >
                <Trans>Back To Login</Trans>
              </Button>
            </Stack>
          </Flex>
        </LoadingOverlay>
      </AuthLayout>
    );
  },
);
